import DefaultBarChart from './DefaultBarChart';

export default DefaultBarChart;
